// Backend API configuration
export const BACKEND_CONFIG = {
  // Base URL for the gait analysis backend API
  BASE_URL: 'https://gait-api.mindtalkbuddy.com',
  // BASE_URL: 'http://localhost:8000',

  
  // Specific endpoints
  ENDPOINTS: {
    ANALYZE_GAIT_FROM_URL: '/analyze-gait-from-url',
  },
  
  // Request timeout in milliseconds (set to null for no timeout)
  TIMEOUT: null, // No timeout - wait indefinitely for video processing to complete
};

// Helper function to get full endpoint URL
export const getApiEndpoint = (endpoint) => {
  return `${BACKEND_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to create API request with keep-alive (no timeout)
export const createApiRequest = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      ...options,
      // Add keep-alive headers to maintain connection indefinitely
      headers: {
        ...options.headers,
        'Connection': 'keep-alive',
        'Keep-Alive': 'timeout=3600', // Request 1 hour keep-alive from server
      },
      // Use keepalive flag for fetch API
      keepalive: true,
    });
    return response;
  } catch (error) {
    // Network errors or other fetch errors
    if (error.name === 'AbortError') {
      throw new Error('Request was aborted.');
    }
    throw error;
  }
};
